<template>
  <div>
    <div class="display-1">plaintiff: {{ plaintiff.fullName }}</div>
    <div class="display-1">matter: {{ matter.caseName }}</div>

    <hr
      size="1px"
      color="#18CAE6"
      style="width: 75%"
      class="ml-auto mr-auto mt-1 mb-1"
    />

    <v-card
      flat
      outlined
      style="background-color: black; border-radius: 26px; border: 3px solid #18CAE6"
    >
      <div class="display-2 text-center">
        PROPOUND DISCOVERY
      </div>
      <div class="subtitle text-center">
        Select Each Form of Discovery You Would Like to Propound Below
      </div>
      <v-layout row wrap class="ma-auto">
        <v-spacer></v-spacer>
        <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800; min-height: 100px"
          outlined
          tile
          rounded
          class="ma-1"
          dense
          hover
        >
          <v-layout column>
            <v-flex class="ma-auto">
              <v-card-text class="headline ma-auto"
                >FORM INTERROGATORIES
              </v-card-text>
            </v-flex>
            <v-flex
              ><v-btn class="ma-auto" small fab color="green" right
                ><v-icon>mdi-check</v-icon></v-btn
              ></v-flex
            >
          </v-layout>
        </v-card>
        <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800; min-height: 100px"
          outlined
          tile
          rounded
          class="ma-1"
          dense
          hover
        >
          <v-layout column>
            <v-flex class="ma-auto">
              <v-card-text class="headline ma-auto"
                >SPECIAL INTERROGATORIES
              </v-card-text>
            </v-flex>
            <v-flex
              ><v-btn class="ma-auto" small fab color="green" right
                ><v-icon>mdi-check</v-icon></v-btn
              ></v-flex
            >
          </v-layout>
        </v-card>
        <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800; min-height: 100px"
          outlined
          tile
          rounded
          class="ma-1"
          dense
          hover
        >
          <v-layout column>
            <v-flex class="ma-auto">
              <v-card-text class="headline ma-auto"
                >REQUESTS FOR PRODUCTION
              </v-card-text>
            </v-flex>
            <v-flex
              ><v-btn class="ma-auto" small fab color="green" right
                ><v-icon>mdi-check</v-icon></v-btn
              ></v-flex
            >
          </v-layout>
        </v-card>
        <v-card
          style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800; min-height: 100px"
          outlined
          tile
          rounded
          class="ma-1"
          dense
          hover
        >
          <v-layout column>
            <v-flex class="ma-auto">
              <v-card-text class="headline ma-auto"
                >REQUESTS FOR ADMISSION
              </v-card-text>
            </v-flex>
            <v-flex
              ><v-btn class="ma-auto" small fab color="green" right
                ><v-icon>mdi-check</v-icon></v-btn
              ></v-flex
            >
          </v-layout>
        </v-card>
        <v-spacer></v-spacer>
      </v-layout>
    </v-card>

    <hr
      size="1px"
      color="#18CAE6"
      style="width: 75%"
      class="ml-auto mr-auto mt-1 mb-1"
    />

    <div class="display-1">
      PLAINTIFFS:
      <div
        class="ml-5"
        v-for="plaintiff in matter.plaintiffs"
        :key="plaintiff.fullName"
      >
        {{ plaintiff.fullName }}
      </div>
      <div class="display-1 ml-10">
        ATTORNEYS:
        <div
          class="ml-5"
          v-for="attorney in matter.attorneys"
          :key="attorney.fullName"
        >
          {{ attorney.fullName }}
        </div>
      </div>
    </div>
    <div class="display-1">
      DEFENDANTS:
      <div
        class="ml-5"
        v-for="defendant in matter.defendants"
        :key="defendant.fullName"
      >
        {{ defendant.fullName }}
      </div>
    </div>
    <div class="display-1">
      SERVICE LIST:
      <div class="ml-5" v-for="item in matter.serviceList" :key="item.phone">
        <div
          v-for="name in item.names"
          :key="name.value"
          class="text-left ml-3"
        >
          {{ name }}
        </div>
        <div class="text-left ml-3">
          {{ item.businessName }}
        </div>
        <div class="text-left ml-3">
          {{ item.address }}
        </div>
        <div class="text-left ml-3">
          {{ item.phone }}
        </div>
        <div class="text-left ml-3">
          {{ item.fax }}
        </div>
        <div
          v-for="email in item.emails"
          :key="email.value"
          class="text-left ml-3"
        >
          {{ email }}
        </div>
        <div class="text-left ml-3">
          {{ item.label }}
        </div>
        <hr style="width: 20%;" />
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
// import { mask } from "vue-the-mask";

// import { degrees, PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
// import { PDFDocument, StandardFonts, rgb, PageSizes } from "pdf-lib";
// import * as moment from "moment";
// import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";

// import * as pdfjsLib from "pdfjs-dist";

// pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  data: () => ({
    plaintiff: null,
    matter: null,
    plaintiffs: [],
    defendants: [],
    attorneyist: [],
    serviceList: null,
  }),
  watch: {
    plaintiff(val) {
      window.document.title = `PROPOUNDING - ${val.fullName.toUpperCase()}`;
    },
  },
  methods: {},
  created() {
    firebase
      .firestore()
      .collection("matters")
      .doc(this.$route.params.id)
      .collection("clients")
      .doc(this.$route.params.client)
      .onSnapshot((doc) => {
        this.plaintiff = doc.data();
      });
    firebase
      .firestore()
      .collection("matters")
      .doc(this.$route.params.id)
      .onSnapshot((doc) => {
        this.matter = doc.data();
      });
  },
};
</script>

<style>
</style>